import {
  Box,
  BoxProps,
  Flex,
  Heading,
  Image,
  Tag,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import { LUEvent } from "../../data/events.api";
import placeholderImg from "../../assets/event-placeholder.jpg";
import moment from "moment";
import { useNavigate } from "react-router-dom";

type Props = BoxProps & {
  event: LUEvent;
};

const EventCard = ({ event, ...boxProps }: Props) => {
  const bg = useColorModeValue("gray.50", "gray.800");
  const navigate = useNavigate();

  return (
    <Flex
      direction="column"
      bg={bg}
      w={48}
      flexShrink={0}
      rounded="md"
      overflow="hidden"
      position="relative"
      cursor="pointer"
      onClick={() => navigate(`/events/${event.eventId}`)}
      {...boxProps}
    >
      <Tag fontSize="xs" position="absolute" top={3} right={3} variant="solid">
        {moment(event.startDate).fromNow()}
      </Tag>
      <Image
        src={event.imageLink ?? placeholderImg}
        objectFit="cover"
        h={24}
        role="img"
        bgSize="cover"
        bgPos={"center"}
      />
      <Box p={2}>
        <Heading size={"xs"} opacity={0.75}>
          {event.title.slice(0, 50)}
          {event.title.length > 50 ? "..." : null}
        </Heading>
      </Box>
    </Flex>
  );
};

export default EventCard;
